import { FilterCogIcon } from './FilterCogIcon';

/**
 * author: Simran
 * id F8F482FA-5AA4-462B-8B38-717FF8568270
 * name filter-cog
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-cog.svg
 * tags
 * - Settings 
 */
export const FunnelGearIcon = FilterCogIcon;
export default FunnelGearIcon